/**
 * API Service
 * Handles all API calls for saving approval memos
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://localhost:7199/api";

/**
 * Save approval memo to API
 * POST /api/Customer
 */
export const saveApprovalMemo = async (memoData) => {
  try {
    const token = localStorage.getItem("token"); // 👈 token yaha se le lo

    const payload = {
      name: memoData.customerName.trim(),
      contactNumber: memoData.mobile,
      date: memoData.invoiceDate,
      isActive: true,
    };

    console.log("📤 Sending to API:", payload);

    const response = await fetch(`${API_BASE_URL}/Customer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/plain",
        "Authorization": `Bearer ${token}`, // 👈 IMPORTANT
      },
      body: JSON.stringify(payload),
    });

    console.log("📥 API Response Status:", response.status);

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `API Error ${response.status}: ${response.statusText} - ${errorText}`
      );
    }

    const responseData = await response.text();

    return {
      success: true,
      data: responseData,
    };

  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};
/**
 * Test API connection
 * Use this to verify API is accessible
 */
export const testAPIConnection = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/Customer`, {
      method: "OPTIONS",
    });

    return {
      connected: true,
      status: response.status,
      apiUrl: API_BASE_URL,
    };
  } catch (error) {
    return {
      connected: false,
      error: error.message,
      apiUrl: API_BASE_URL,
    };
  }
};

/**
 * Get API base URL (for debugging)
 */
export const getAPIBaseUrl = () => API_BASE_URL;